// eslint-disable-next-line import/prefer-default-export
export const NOTIFICATIONS = {
  ctpOptIn: 'ctpOptIn',
} as const;
